import { render, staticRenderFns } from "./scrollToTop.vue?vue&type=template&id=70c44804&scoped=true&"
import script from "./scrollToTop.vue?vue&type=script&lang=js&"
export * from "./scrollToTop.vue?vue&type=script&lang=js&"
import style0 from "./scrollToTop.vue?vue&type=style&index=0&id=70c44804&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c44804",
  null
  
)

export default component.exports